/**
 * Provider-Setup — der zentrale Schaltpunkt Mock ↔ Firebase.
 *
 * Der Rest der App kennt nur `services.*` (Provider-agnostisch); die Wahl des
 * Backends passiert ausschließlich hier. Zum Umschalten den aktiven Block
 * auskommentieren und den anderen einkommentieren — `politik-portal-app.ts` bleibt
 * unberührt.
 *
 * Bewusst ein Kommentar-Toggle statt einer Env-Variable: bei statischen
 * Imports bleibt Tree-Shaking wirksam — der Mock-Build bundelt kein
 * Firebase-SDK und umgekehrt.
 */

// import { createMockProvider } from "@progressive-development/pd-provider-mock";
import { createFirebaseProvider } from "@progressive-development/pd-provider-firebase";

// import { appMockFixtures } from "./mock-fixtures.js";

import { DB_SHARED } from "./collections.js";

/** Fürs Startup-Log in politik-portal-app.ts. */
export const PROVIDER_NAME = "firebase";

// =============================================================================
// Variante A: Mock-Provider — läuft ohne externe Abhängigkeiten.
// Demo-Logins: siehe mock-fixtures.ts (demo@app.local / demo123).
//
// ZUM ZURÜCKSCHALTEN: diesen Block einkommentieren, Variante B auskommentieren
// und oben die beiden Import-Zeilen tauschen.
// =============================================================================

// export function createAppProvider() {
//   return createMockProvider({
//     fixtures: appMockFixtures,
//     defaultDelay: 400, // simulierte Netzwerk-Latenz, um Loading-States zu sehen
//     persistAuth: true, // Login übersteht Reload (localStorage)
//     logging: import.meta.env.DEV,
//   });
// }

// =============================================================================
// Variante B (AKTIV): Firebase.
//
// Stand: Die Fach-Daten liegen in der Datenbank `politik` (von der Pipeline
// befüllt, öffentlich lesbar). Was damit geht und was nicht:
//
//   geht    — /entscheidungen, die Drucksachen-Detailseite, /sitzungen/:id
//   geht    — die Suche, sobald jemand tippt (lädt dann den Suchindex)
//   NICHT   — die Startseite: ihr Dokument (Collection `startseite`) exportiert
//             die Pipeline noch nicht
//   NICHT   — Mein Bereich, Profil, Merkliste: die Functions sind nicht
//             ausgerollt, und Demo-Logins gibt es nur im Mock
//   NICHT   — gefilterte Listen, für die noch kein Index deployt ist; Firestore
//             nennt den fehlenden Index dann mit einem Link in der Konsole
// =============================================================================

export function createAppProvider() {
  return createFirebaseProvider({
    firebaseConfig: {
      apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
      authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
      projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
      storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
      appId: import.meta.env.VITE_FIREBASE_APP_ID,
    },
    functionsRegion: "europe-west3",
    // Die Fach-Daten liegen in einer EIGENEN Datenbank: öffentlich lesbar, von
    // der Pipeline geschrieben, mit eigenen Regeln (firestore-politik.rules).
    // Welche Datenbank die App adressiert, wird hier einmal entschieden und
    // nicht an jeder Aufrufstelle.
    enableDatabase: true,
    databaseId: "politik",
    // Portalübergreifende Nachschlagewerke (Gebiete, Parteien, Wahlen) liegen
    // in der geteilten Vorgabe-Datenbank: Ein anderes Stadt-Portal soll einen
    // Stadtteil einfärben können, ohne in die Politik-Datenbank zu greifen.
    // Der NAME ist nötig, weil `verzeichnisse` in beiden Datenbanken existiert
    // und dort Verschiedenes bedeutet.
    databases: { [DB_SHARED]: "(default)" },
    // functionsEmulator: { host: "localhost", port: 5001 },
  });
}
